
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { useEffect, useState } from 'react';

export default function TrustBar() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>({ threshold: 0.3 });
  const [counts, setCounts] = useState([0, 0, 0, 0]);

  const trustItems = [
    { icon: 'ri-checkbox-circle-fill', text: 'Gifts Reviewed', color: 'text-[#1B4332]', count: 500 },
    { icon: 'ri-star-fill', text: 'Expert Reviews', color: 'text-[#D4AF37]', count: null },
    { icon: 'ri-refresh-line', text: 'Updated Daily', color: 'text-[#1B4332]', count: null },
    { icon: 'ri-shield-check-fill', text: 'Verified Links', color: 'text-[#8B2635]', count: null }
  ];

  useEffect(() => {
    if (isVisible) {
      const duration = 2000;
      const steps = 60;
      const interval = duration / steps;
      
      let step = 0;
      const timer = setInterval(() => {
        step++;
        const progress = step / steps;
        const easeOut = 1 - Math.pow(1 - progress, 3);
        
        setCounts([
          Math.round(500 * easeOut),
          0,
          0,
          0
        ]);
        
        if (step >= steps) clearInterval(timer);
      }, interval);
      
      return () => clearInterval(timer);
    }
  }, [isVisible]);

  return (
    <section 
      ref={ref}
      className="bg-gradient-to-r from-[#D4AF37]/10 via-[#D4AF37]/5 to-[#D4AF37]/10 border-y border-[#D4AF37]/20 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {trustItems.map((item, index) => (
            <div 
              key={index} 
              className={`flex items-center justify-center gap-3 group cursor-pointer transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className={`w-12 h-12 flex items-center justify-center ${item.color} group-hover:scale-125 group-hover:rotate-12 transition-all duration-300`}>
                <i className={`${item.icon} text-2xl ${index === 1 ? 'animate-sparkle' : ''}`}></i>
              </div>
              <span className="font-semibold text-[#1B4332] text-sm lg:text-base">
                {item.count !== null ? (
                  <span className="tabular-nums">{counts[index]}+ {item.text}</span>
                ) : (
                  item.text === 'Expert Reviews' ? 'Unbiased Expert Reviews' : 
                  item.text === 'Updated Daily' ? 'Updated Daily' : 
                  'Amazon Verified Links'
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
